<template>
  <div class="col-lg-4 col-md-6 col-12" >
  </div>
  <!-- <h6 class="mb-3">Track del Pedido</h6>
  <div class="timeline timeline-one-side">
    <div  v-for="(track, index) of tracking" :key="index" class="timeline-block mb-3">
      <span class="timeline-step">
        <i :class="getIcon(track)" class="text-secondary"></i>
      </span>
      <div class="timeline-content">
        <h6 class="text-primary text-sm font-weight-bold mb-0">
          {{ track.status }}
        </h6>
        <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
          {{ $dateUtils.fromNow(track.date) }}
        </p>
        <soft-button v-if="track.relatedEntity!=null" class="mt-2" color="success" size="sm" @click="goActionTracking(track)">{{ getLabelButton(track) }}</soft-button>
      </div>
    </div>
  </div> -->
</template>

<script>

  export default {
    name: "ShipmentTracking",
    props: {
      tracking: {
        type: Array,
        default: ()=> [],
      },
    },  
    data() {
      return {};
    },
    methods: {
      getIcon(track){
        switch (track.status) {
          case "CREATED":
            return "ni ni-bell-55";
          case "IN PROGRESS":
            return "fa fa-spinner";
          case "COMPLETED":
            return "ni ni-check-bold";
          case "SHIPPED":
            return "ni ni-cart";
          default:
            return "ni ni-bell-55";
        }
      },
      getLabelButton(track) {
        if (track.status === "SHIPPED") {
          return "Ver Envío";
        }
        return "Accion No Definida";
      },
      goActionTracking(track){
        if (track.status === "SHIPPED") {
          this.$router.push({ name: "envio" });
        }
      }

    },
  };

</script>